export const getColumnsFromTableView = tableView =>
    tableView.tables.flatMap((table, parentIndex) => {
        const flattenCols = (children) => {
            return children.flatMap(child => {
                if (child.children) {
                    return flattenCols(child.children);
                }
                if (child.col) {
                    // Removing initialHide from the col, we should use isDisplayed instead
                    // eslint-disable-next-line no-unused-vars
                    const { initialHide, ...colWithoutInitialHide } = child.col;
                    return [{ ...colWithoutInitialHide, parentIndex }];
                }
                return [];
            });
        };
        return flattenCols(table.children);
    });
